import React from 'react';
import useCondition from '../../../useCondition';
import useFilterModalContext from '../../useFilterModalContext';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';
import {useClientPhaseProspectsQuery} from 'api';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {condition, setCondition} = useCondition();

  const {data: {clientPhaseProspects = []} = {}} = useClientPhaseProspectsQuery(
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  if (
    !condition?.clientPhaseProspects ||
    !condition?.clientPhaseProspects.length
  ) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">フェーズ</h4>
        <button
          onClick={() => setFilterType('clientPhaseProspect')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() => setCondition({clientPhaseProspects: []})}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex flex-wrap items-center gap-1">
        {clientPhaseProspects
          .filter(
            (clientPhaseProspect) =>
              condition?.clientPhaseProspects.includes(clientPhaseProspect.id),
          )
          .map((clientPhaseProspect) => (
            <span
              key={clientPhaseProspect.id}
              className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
              {clientPhaseProspect.name}
            </span>
          ))}
      </div>
    </div>
  );
};
